import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Antd from 'ant-design-vue';
import axios from 'axios';
import Store from "./api/store.js";
import  "@/api/axios.js";
import global from './api/global.js';
import Common from './api/common.js';
import Business from './api/business.js';
import 'ant-design-vue/dist/antd.css';
import { message } from 'ant-design-vue';

Vue.config.productionTip = false;
Vue.use(Antd);
Vue.use(Common);
Vue.use(Business);

Vue.prototype.$axios = axios;
Vue.prototype.$pagination = global.pagination;

const store = Store;
//消息提示框位置配置
Vue.prototype.$message = message;
message.config({
  top: '50%',
  duration: 2,
  maxCount: 3,
});

//获取系统信息
axios.get('/api/dmz/tenant').then(function(res){
  if(res.msg.flag == 0){
    if(undefined != res.biz && null != res.biz){
      localStorage.setItem('platform', JSON.stringify(res.biz));
    }
  }
},function(res){
});

router.beforeEach((to,from,next)=>{
  if(to.meta.requireAuth){
    if(localStorage.getItem('token')){
      next();
    }else{
      next({
        path:'/login',
        query: {redirect: to.fullPath}
      });
    }
  }else{
    next();
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

